import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { AuthActions, SiteContextActions } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, groupBy, map, mergeMap, switchMap } from 'rxjs/operators';
import { normalizeHttpError, withdrawOn } from '../../../../../../core/util';
import { NewsConnector } from '../../connectors';
import { NewsActions } from '../actions';

@Injectable()
export class NewsEffects {
  private contextChange$: Observable<Action> = this.actions$.pipe(
    ofType(SiteContextActions.LANGUAGE_CHANGE, AuthActions.LOGOUT, AuthActions.LOGIN)
  );

  loadNews$: Observable<NewsActions.LoadNewsSuccess | NewsActions.LoadNewsFail> = createEffect(() =>
    this.actions$.pipe(
      ofType<NewsActions.LoadNews>(NewsActions.NewsActionTypes.LoadNews),
      groupBy(({ count }) => count),
      mergeMap((group) =>
        group.pipe(
          switchMap((payload) =>
            this.newsConnector.loadNews(payload.count).pipe(
              map((data) => new NewsActions.LoadNewsSuccess(payload.count, data)),
              catchError((error) => of(new NewsActions.LoadNewsFail(payload.count, normalizeHttpError(error)))),
              withdrawOn(this.contextChange$)
            )
          )
        )
      )
    )
  );

  constructor(private actions$: Actions, private newsConnector: NewsConnector) {}
}
